import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const organizationDetailsSelector = createSelector(stateSelector, (state) => state.organizationDetails);

const ableToEnforceGoogleSelector = createSelector(
  organizationDetailsSelector,
  (organization) => organization.is_able_to_enforce_google,
);

const ableToEnforceAmazonSelector = createSelector(
  organizationDetailsSelector,
  (organization) => organization.is_able_to_enforce_amazon,
);

const ableToEnforceOidcSelector = createSelector(
  organizationDetailsSelector,
  (organization) => organization.is_able_to_enforce_oidc,
);

const isForcedUsingGoogle = createSelector(
  organizationDetailsSelector,
  (organization) => organization.enforce_google_auth,
);

const organizationDetailsUpdateStatusSelector = createSelector(
  stateSelector,
  (state) => state.organizationDetailsUpdateStatus,
);

const organizationDetailsEditModeSelector = createSelector(stateSelector, (state) => state.organizationDetailsEditMode);

const googleLoginUpdateStatusSelector = createSelector(stateSelector, (state) => state.googleLoginUpdateStatus);
const amazonLoginUpdateStatusSelector = createSelector(stateSelector, (state) => state.amazonLoginUpdateStatus);
const oidcLoginUpdateStatusSelector = createSelector(stateSelector, (state) => state.oidcLoginUpdateStatus);

const editingOrganizationLoaderSelector = createSelector(stateSelector, (state) => state.editingOrganizationLoader);

const isLoadingOrganizationSelector = createSelector(stateSelector, (state) => state.isLoadingOrganization);

const updateError = createSelector(stateSelector, (state) => state.updateError);
const shouldRedirectToCreditCardSelector = createSelector(
  stateSelector,
  (state) => state.shouldGetRedirectedToCreditCard,
);

const strongPasswordPolicySelector = createSelector(organizationDetailsSelector, (orgDetails) => {
  const passwordSettings = orgDetails.password_settings;
  if (passwordSettings) {
    try {
      const parsedSettings = JSON.parse(passwordSettings);
      return parsedSettings.validators.length_validator;
    } catch (e) {
      return true;
    }
  }
  return true;
});

const organizationIPWhitelistSelector = createSelector(stateSelector, (state) => state.organizationIPWhitelist);

export const OrganizationSelectors = {
  isLoadingOrganizationSelector,
  isForcedUsingGoogle,
  organizationIPWhitelistSelector,
  editingOrganizationLoaderSelector,
  organizationDetailsSelector,
  organizationDetailsUpdateStatusSelector,
  googleLoginUpdateStatusSelector,
  amazonLoginUpdateStatusSelector,
  oidcLoginUpdateStatusSelector,
  updateError,
  organizationDetailsEditModeSelector,
  shouldRedirectToCreditCardSelector,
  ableToEnforceGoogleSelector,
  ableToEnforceAmazonSelector,
  ableToEnforceOidcSelector,
  strongPasswordPolicySelector,
};
